import React from "react";
import Categories from "../../components/Categories";

function CategoriesPage() {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <Categories />
      </div>
    </div>
  );
}

export default CategoriesPage;
